import React, {memo} from "react";
import {Button} from "@mui/material";
import slugify from "slugify";
import {PDFDownloadLink} from "@react-pdf/renderer";

import {FormPaperColorEnum} from "../Types";
import {useAppStore} from "../Stores";
import {getLabelConfig} from "../Utils";

export const Download: React.FC = memo(() => {
  const labelType = useAppStore.use.labelType();
  const config = getLabelConfig(labelType);

  if (!config) {
    throw new Error('Impossible de récupérer la configuration du type d\'étiquette ' + labelType + '.');
  }

  const printOptions = useAppStore.use.printOptions();
  const labels = useAppStore.use.labels();

  const PdfComponent = config.components.pdf;

  return (
    <PDFDownloadLink
      fileName={slugify('affichette', {
        replacement: "-",
        lower: true,
      })}
      document={
        <PdfComponent printOptions={{...printOptions, paperColor: FormPaperColorEnum.WHITE}} labels={labels} />
      }
      style={{textDecoration: "none"}}
    >
      {/* @ts-ignore */}
      {({ blob, url, loading, error }) => {
        return (
          <Button
            fullWidth
            variant="contained"
            sx={{mt: 3, mb: 2}}
            color="info"
            disabled={loading || !!error}
          >
            {loading ? 'Chargement...' : error ? 'Une erreur s\'est produite' : 'Télécharger'}
          </Button>
        );
      }}
    </PDFDownloadLink>
  );
});

export default Download;
